import * as React from "react"
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query'

const queryClient = new QueryClient()

function useLuckyNumber() {
  return useQuery({
    queryKey: ['luckyNumber'],
    queryFn: () => {
      return Promise.resolve(Math.random())
    }
  })
}

function FortuneCookie() {
  const { data } = useLuckyNumber()

  if (data > 0.5) {
    return <div>Today's your lucky day</div>
  }

  return <div>Better stay home today</div>

}

function LuckyNumber() {
  const { data } = useLuckyNumber()

  return (
    <div>Lucky Number is: {data}</div>
  )
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LuckyNumber />
      <FortuneCookie />
    </QueryClientProvider>
  )
}
